/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import Modal from '~/components/Modal'
import { useTranslation } from 'react-i18next'

interface FsiPropertiesConfirmScreenModalProps {
  closeParentModal: () => void
  onClose?: () => void
  onStay?: () => void
}

const FsiPropertiesConfirmScreenModal: React.FC<FsiPropertiesConfirmScreenModalProps> = ({
  closeParentModal,
  onClose,
  onStay
}) => {
  const { t: translate } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(true)
  }, [])

  const doClose = () => {
    setIsOpen(false)
    if (onClose) {
      onClose()
    }
  }

  const handleStay = () => {
    doClose()
    if (onStay) {
      onStay()
    }
  }

  return (
    <>
      <div>
        <Modal
          show={isOpen}
          title={translate('PROPERTIES_LEAVE_SCREEN_TITLE')}
          handleClose={() => {
            doClose()
            closeParentModal()
          }}
        >
          <Modal.Body>
            <Form.Label>{translate('PROPERTIES_LEAVE_SCREEN_BODY')}</Form.Label>
          </Modal.Body>
          <Modal.Footer>
            <Button
              data-action={'ok'}
              variant="link"
              onClick={() => {
                doClose()
                closeParentModal()
              }}
              id="8ee668eb-1fb9-4a26-af74-85cd16f96455"
            >
              {translate('LEAVE')}
            </Button>
            <Button
              data-action={'ok'}
              className="btn btn-primary "
              onClick={handleStay}
              id="e226c874-9bbe-4e67-8b0c-5abfbd4b2f34"
            >
              {translate('STAY')}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}

export default FsiPropertiesConfirmScreenModal
